import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      closeButton
      position="bottom-right"
      richColors
      toastOptions={{
        classNames: {
          closeButton: '!left-auto !right-0.5 !top-2 !translate-x-0 !translate-y-0',
        },
      }}
    />
  );
}
